const base = APPLICATION_ENV.MANAGE_API;
const apis = {
  dashboard: {
    userStatistics: `${base}backplat/nanpuxi/user_data`, // 用户统计
    goodsStatistics: `${base}backplat/nanpuxi/manage_data`, // 商品统计
  },
};

export default apis;
